export default {
  "content": "<title>Ear</title><path d=\"M335.72 330.76C381.73 299.5 416 251.34 416 192a160 160 0 00-320 0v206.57c0 44.26 35.74 81.43 80 81.43s66.83-25.94 77.29-40c14.77-19.81 41.71-81.56 82.43-109.24z\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M160 304V184c0-48.4 43.2-88 96-88s96 39.6 96 88\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M160 239c25-18 79.82-15 79.82-15 26 0 41.17 29.42 26 50.6 0 0-36.86 42.4-41.86 61.4\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};